function NRPacmanIcon({ height = '24', width = '24', color = '#1793D1' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9963 2C11.1061 4.18258 10.5692 5.6102 9.57796 7.72782C10.1856 8.37186 10.9315 9.12204 12.1429 9.96925C10.8406 9.43332 9.95223 8.89523 9.28851 8.33698C8.02008 10.9838 6.03273 14.754 2 21.9998C5.16965 20.1702 7.62665 19.0419 9.91652 18.6115C9.8131 18.1664 9.7626 17.7107 9.76609 17.2538L9.76989 17.1523C9.82014 15.1216 10.8765 13.5601 12.1279 13.6659C13.3793 13.772 14.3519 15.5051 14.3017 17.5358C14.2921 17.918 14.249 18.2857 14.1737 18.6265C16.4386 19.0696 18.8694 20.1948 21.9962 22C21.3796 20.865 20.8293 19.8417 20.3038 18.8674C19.476 18.2256 18.6126 17.3907 16.8514 16.4866C18.062 16.8012 18.9287 17.1642 19.6043 17.5697C14.261 7.62185 13.8284 6.30004 11.9963 2Z"
        fill={color}
      />
    </svg>
  );
}
export default NRPacmanIcon;
